module.exports = __webpack_public_path__ + "static/img/car.2878347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/car.svg
// module id = iYMA
// module chunks = 0